import template from './projectManager.html';
import controller from './projectManager.controller';
import './projectManager.scss';

let projectManagerComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default projectManagerComponent;



// WEBPACK FOOTER //
// ./client/app/components/apps/projectManager/projectManager.component.js